import React from 'react'
import {
  TableBodyRow,
  TableBody,
} from 'src/components/TableComponents'
import { useTheme } from 'styled-components'
import * as S from '../../styles'
import { ReceivementProductWrapper } from '../../../ReceivementProductWrapper'
import { ReceivementBatchFinish, ReceivementProductFinish } from 'src/features/receivement/ReceivementTypes'
import { measureUnit, NumberFmt } from 'src/utils'
import { ReceivementFinishObservations } from '../../../ReceivementFinishObservations'

interface Props {
  product: ReceivementProductFinish
  headerColor?: string;

}

const CorrectProductTable = ({ product, headerColor }: Props) => {
  const theme = useTheme()

  const { batches } = product

  const isKg = batches.length > 0 ? batches[0].isKg : false
  const hasObservations = product.observations.length > 0

  const resolveTotalAcceptedQuantity = () => batches.reduce((partialSum, batch) => partialSum + batch.acceptedQuantity, 0)
  const resolveTotalReceivableQuantity = () => batches.reduce((partialSum, batch) => partialSum + batch.totalQuantity, 0)
  const resolveTotalSwapQuantity = () => batches.reduce((partialSum, batch) => partialSum + batch.swapQuantity, 0)

  return (
    <>
      <ReceivementProductWrapper>
        <S.Table>
          <S.TableHeader
            backgroundColor={headerColor}
            columnInformation={[
              { columnName: 'Produto' },
            ]}
            flexColumns={[
              1,
            ]}
          />
          <TableBody style={{ marginBottom: hasObservations ? '8px' : '0px' }}>
            <TableBodyRow backgroundColor={theme.colors.white}>
              <S.TableBodyCell flex={1}>{product.productDescription}</S.TableBodyCell>
            </TableBodyRow>
            {hasObservations
            && <ReceivementFinishObservations observations={product.observations} modelId={product.modelId}/>}
          </TableBody>
          <S.TableHeader
            backgroundColor={theme.colors.gray}
            columnInformation={[
              { columnName: 'Lote' },
              { columnName: 'Qtd. Recebida' },
              { columnName: 'Qtd. a Aceitar' },
              { columnName: 'Troca Futura', tooltipMessage: 'Parte da Qtd. a Aceitar reservada para trocas futuras' },
            ]}
            flexColumns={[
              1 / 4,
              1 / 4,
              1 / 4,
              1 / 4,
            ]}
          />
          <TableBody>
            {batches.map((adjustmentBatch: ReceivementBatchFinish) => (
              <TableBodyRow key={adjustmentBatch.batchId} backgroundColor={theme.colors.white}>
                <S.TableBodyCell flex={1 / 4}>{adjustmentBatch.batchId}</S.TableBodyCell>
                <S.TableBodyCell flex={1 / 4}><NumberFmt value={adjustmentBatch.totalQuantity} sufix={measureUnit(adjustmentBatch.isKg)} /></S.TableBodyCell>
                <S.TableBodyCell flex={1 / 4}><NumberFmt value={adjustmentBatch.acceptedQuantity} sufix={measureUnit(adjustmentBatch.isKg)} /></S.TableBodyCell>
                <S.TableBodyCell flex={1 / 4}><NumberFmt value={adjustmentBatch.swapQuantity} sufix={measureUnit(adjustmentBatch.isKg)} /></S.TableBodyCell>
              </TableBodyRow>
            ))}
          </TableBody>

          <S.TableHeader
            backgroundColor={theme.colors.gray}
            columnInformation={[
              { columnName: '' },
              { columnName: 'Total Recebido' },
              { columnName: 'Total a Aceitar' },
              { columnName: 'Total Troca Futura', tooltipMessage: 'Parte da Qtd. a Aceitar reservada para trocas futuras' },
            ]}
            flexColumns={[
              1,
              1,
              1,
              1,
            ]}
          />
          <S.TableBody>
            <TableBodyRow backgroundColor={theme.colors.white}>
              <S.TableBodyCell flex={1}/>
              <S.TableBodyCell flex={1}><NumberFmt value={resolveTotalReceivableQuantity()} sufix={measureUnit(isKg)} /></S.TableBodyCell>
              <S.TableBodyCell flex={1}><NumberFmt value={resolveTotalAcceptedQuantity()} sufix={measureUnit(isKg)} /></S.TableBodyCell>
              <S.TableBodyCell flex={1}><NumberFmt value={resolveTotalSwapQuantity()} sufix={measureUnit(isKg)} /></S.TableBodyCell>
            </TableBodyRow>
          </S.TableBody>
        </S.Table>
      </ReceivementProductWrapper>
    </>
  )
}

export { CorrectProductTable }
